import { get } from 'lodash';
import findResult, { jsonTryParse } from '@/utils/resultsHelper';
import urls, { datasetUrl, kbUrl } from '@/constants/urls';
import { vocabularyCodes } from '@/vocabularies/constants';
import { encodeQueryOmni } from './searchHelper';

const searchKB = (value) => {
  window.open(kbUrl(value), 'knowledgebase');
};

export const isAllowed = (itemPermissions, userPermissions) => {
  if (!itemPermissions) {
    return true;
  }

  let allowed = false;
  itemPermissions.some((itemPermission) => {
    allowed = itemPermission.every((permission) => get(userPermissions, permission));
    return allowed;
  });

  return allowed;
};

export const kbResults = ({ query }, intl) => ({
  kb: {
    name: intl.formatMessage({ id: 'search.kb.category' }),
    results: [
      {
        title: intl.formatMessage({ id: 'kb.filter.title' }, { value: `'${query}'` }),
        description: intl.formatMessage({ id: 'kb.filter.description' }),
        onClick: () => searchKB(query),
      }],
  },
});

export const searchResults = (navigate, { results }, intl) => (
  results.length > 0
    ? {
      search: {
        name: intl.formatMessage({ id: 'search.datasets.category' }),
        results: results.map((item) => ({
          id: item.id,
          title: item.name || item.title,
          description: `${item.description.substring(0, 150)}...`,
          onClick: () => navigate(datasetUrl(item)),
        })),
      },
    } : {}
);

export const advancedSearchResult = (navigate, { query }, intl) => ({
  id: 'advancedSearchOmni',
  title: intl.formatMessage({ id: 'home.banner.advanced.search.dropdown' }),
  onClick: () => navigate(encodeQueryOmni(query)),
});

export const externalLinks = (linksFlag, vocabularies) => {
  const name = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.EXTERNAL_URLS_NAME) : null;
  const links = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.EXTERNAL_URLS) : null;

  return ({
    linksName: name ? name.value : '',
    links: links ? jsonTryParse(links.value, []) : [],
  });
};

export const searchLinks = (linksFlag, vocabularies) => {
  const name = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.SEARCH_URLS_TITLE) : null;
  const links = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.SEARCH_URLS) : null;

  return ({
    searchLinksName: name ? name.value : '',
    searchLinks: links ? jsonTryParse(links.value, []) : [],
  });
};

export const omniSearchLinks = ({ linksFlag, kbFlag, datasetsFlag }, vocabularies) => {
  const feedbackLink = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.FEEDBACK_URL) : null;
  const termsLink = linksFlag ? findResult(vocabularies, 'all', vocabularyCodes.T_AND_C_URL) : null;
  const termsDefault = linksFlag ? urls.T_AND_C : '';

  return ({
    feedbackLink: feedbackLink ? feedbackLink.value : '',
    termsLink: termsLink ? termsLink.value : termsDefault,
    ...searchLinks(linksFlag, vocabularies),
    ...externalLinks(linksFlag, vocabularies),
    showLinks: linksFlag,
    showKbLink: kbFlag,
    showDatasets: datasetsFlag,
    categorise: linksFlag || [kbFlag, datasetsFlag].filter((x) => x === true).length > 1,
  });
};
